var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"CatalogosPresentaciones"}},[_c('navegacion',{staticClass:"mb-4"}),_c('presentaciones-quicktable',{attrs:{"disable-new-modal":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }